var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-datatable',{attrs:{"fields":_vm.getFields(),"resources":_vm.resources,"loading":_vm.loading,"pagination":_vm.pagination,"route":_vm.$route,"router":_vm.$router,"no-data-label":_vm.$t('components.data_table.empty')},on:{"fetch":_vm.fetchResources}})
}
var staticRenderFns = []

export { render, staticRenderFns }